import React, { useEffect, useState } from 'react';
import { TEXT } from "Clients/ACCB/ACCBTheme";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  makeStyles,
} from '@material-ui/core';
import instance from 'api/globalaxios';

const useStyles = makeStyles(() => ({
  label: {
    color: TEXT.strong,
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.3125rem',
    textAlign: 'left',
    marginBottom: '0.2rem',
  },
}));

const StageInputField = ({
  value,
  onChange,
  isRequired = false,
  isLabel = true,
  inlineLabel = false,
  label = 'Stage',
  name = 'stage',
  size = 'medium',
  error = null,
}) => {
  const classes = useStyles();
  const [stages, setStages] = useState([]);

  useEffect(() => {
    instance
      .get('/bac/masters/arbitration-stage/', {
        params: {
          pagination: false,
        }
      })
      .then((res) => {
        setStages(res?.data?.results || []);
      })
      .catch((err) => {
        console.error('Error fetching stages', err);
      });
  }, []);

  // Resolve parent's value to the ID of the matched stage name or ID
  const getSelectedValue = () => {
    if (!value) return '';
    let resolvedValue = value;
    if (typeof value === 'object') {
      resolvedValue = value.id || value.stage || value.name || '';
    }
    const matchedStage = stages.find(
      (s) =>
        String(s.id) === String(resolvedValue) ||
        String(s.stage).trim().toLowerCase() === String(resolvedValue).trim().toLowerCase()
    );
    return matchedStage ? matchedStage.id : '';
  };

  // Synchronize value to parent if it is currently represented as name or object,
  // so the parent's state gets updated to the clean ID needed for API calls.
  useEffect(() => {
    if (!value || stages.length === 0) return;

    let resolvedValue = value;
    if (typeof value === 'object') {
      resolvedValue = value.id || value.stage || value.name || '';
    }

    if (!resolvedValue) return;

    const matchedStage = stages.find(
      (s) =>
        String(s.id) === String(resolvedValue) ||
        String(s.stage).trim().toLowerCase() === String(resolvedValue).trim().toLowerCase()
    );

    if (matchedStage) {
      const isCurrentValueObject = typeof value === 'object';
      const isCurrentValueDifferent = String(value) !== String(matchedStage.id);

      if (isCurrentValueObject || isCurrentValueDifferent) {
        if (onChange) {
          onChange({ target: { name, value: matchedStage.id } });
        }
      }
    }
  }, [value, stages, name, onChange]);

  const labelId = `${name}-label`;

  return (
    <>
      <FormControl required={isRequired} fullWidth margin="none" variant="outlined" size={size}>
        {inlineLabel
          ? isLabel && <InputLabel id={labelId}>{label}</InputLabel>
          : isLabel && (
              <Typography className={classes.label}>
                {label}
                {isRequired && <span style={{ color: 'red' }}> *</span>}
              </Typography>
            )}
        <Select
          labelId={inlineLabel ? labelId : undefined}
          label={inlineLabel ? label : undefined}
          name={name}
          value={getSelectedValue() || ''}
          onChange={onChange}
        >
          {!inlineLabel && <MenuItem value="">Select</MenuItem>}
          {stages.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.stage}
            </MenuItem>
          ))}
        </Select>
        {error && (
          <FormHelperText style={{ color: 'red', margin: 0 }}>{error}</FormHelperText>
        )}
      </FormControl>
    </>
  );
};

export default StageInputField;
